"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HammerSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M28.38,6a5,5,0,0,0-4-2H23.8A3,3,0,0,0,21,2H12A3,3,0,0,0,9,5H7A2,2,0,0,0,3,5v6a2,2,0,0,0,4,0H9a3,3,0,0,0,3,3h9a3,3,0,0,0,3-3V10h.67l.8.26a2.49,2.49,0,0,0,.85.14A2.69,2.69,0,0,0,29,8.16,2.81,2.81,0,0,0,28.38,6Z"/><path d="M12,25.35v.16a4.4,4.4,0,0,0,2.54,4.07A4.53,4.53,0,0,0,21,25.5v-.15L20.12,14H12.88ZM16.5,23a2,2,0,1,1-2,2A2,2,0,0,1,16.5,23Z"/>';
var HammerSVG = function HammerSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.HammerSVG = HammerSVG;
HammerSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(HammerSVG);
exports.default = _default;